import { fetchProducts, getProductDetails } from '../../api/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Product } from '../reducers/productReducers'

const fetchProductsAPI = createAsyncThunk(
  'product/fetch-products',
  async () => {
    const response = await fetchProducts()
    return response.data
  }
)

const fetchProductDetailsAPI = createAsyncThunk<
  { success: boolean; product: Product },
  string,
  { rejectValue: { success: boolean; message: string } }
>('product/fetch-product-details', async (productID, { rejectWithValue }) => {
  const response = await getProductDetails(productID)
  if (!response.data.success) {
    return rejectWithValue(response.data)
  }
  return response.data
})

// export const deleteProductById = (id: string) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
//   const data = await deleteProduct(id)
//   console.log(data)
//   dispatch({
//     type: DELETE_PRODUCT,
//     payload: data.products,
//   })
// }
// export const updateProductById = (form: unknown) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
//   const data = await updateProduct(form)
//   dispatch({
//     type: UPDATE_PRODUCT,
//     payload: data.products,
//   })
// }

export { fetchProductsAPI, fetchProductDetailsAPI }
